import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DashboardAdmin from "./DashboardAdmin";
import { AUTH_URL } from "../../utils/constants";
import bgOfficer from "../../assets/images/bg_officer.png";
import { useAuth } from "../../utils/AuthContext";

const OfficerDashboard = () => {
  const [data, setData] = useState([]);
  const [overdueData, setOverdueData] = useState([]);

  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(false);
  const [queryUpdate, setQueryUpdate] = useState(true);
  const { user } = useAuth();


  const fetchQueries = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${AUTH_URL}api/allqueryofficer?officer_name=${encodeURIComponent(user.category)}`, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.data) {
        const apiPayload = Array.isArray(res.data?.data) ? res.data?.data : res.data?.data.queries || [];
        const reversed = Array.isArray(apiPayload) ? [...apiPayload].reverse() : [];

        const normalizeStatus = (status) => {
          const s = (status || 'pending').toLowerCase();
          if (s === 'pending') return 'Pending';
          if (s === 'resolved' || s === 'closed') return 'Resolved';
          if (s === 'rejected') return 'Rejected';
          if (s === 'responded') return 'Responded';
          return 'Other';
        };

        const buildStatusSummary = (items) => {
          const summaryMap = {};
          items.forEach((item) => {
            const status = item.officer_grievance_status;
            if (!summaryMap[status]) {
              summaryMap[status] = {
                name: status,
                count: 0,
                // percentage: item.percentage ?? 0,
              };
            }
            summaryMap[status].count += 1;
          });
          return Object.values(summaryMap);
        };

        const summary = Array.isArray(res.data?.data.summary)
          ? res.data?.data.summary
          : buildStatusSummary(reversed);

        setData(reversed);
        const resolved = reversed.filter((i) => i.officer_grievance_status === "Resolved");
        setDashboardData({
          total: reversed.length,
          pending: reversed.length - resolved.length,
          closed: resolved.length,
          summary,
        });
        setQueryUpdate(false);
      }
    } catch (err) {
      console.error("Error fetching queries:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (queryUpdate) fetchQueries();
  }, [queryUpdate]);

  useEffect(() => {
    console.log("overdue query dashboard");
    const getAdminQueriesCall = async () => {
      setLoading(true);
      try {
        let res = await axios.get(`${AUTH_URL}api/grievance_tat_exceeded_officer?officer_name=${encodeURIComponent(user.category)}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (res.data) {
          const apiPayload = Array.isArray(res.data?.data) ? res.data?.data : res.data?.data.queries || [];

          setOverdueData(apiPayload);

        }
      } catch (error) {
        console.log("there is some error", error);
      } finally {
        setLoading(false);
      }
    };
    if (queryUpdate) {
      getAdminQueriesCall();
    }
  }, [queryUpdate]);

  const activeDashboardData = {
    total:   dashboardData.total   ?? data.length,
    pending: dashboardData.pending ?? data.filter(d => d.officer_grievance_status !== "Resolved").length,
    closed:  dashboardData.closed  ?? data.filter(d => d.officer_grievance_status === "Resolved").length,
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgOfficer})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="px-4 py-5 box-border w-full h-full"
    >
      <DashboardAdmin 
        user={user} 
        dashboardData={activeDashboardData} 
        data={data} 
        setQueryUpdate={setQueryUpdate} 
        overdueData={overdueData} 
      />
    </div>
  );
};

export default OfficerDashboard;
